/**
 * Barrel for generated icon shells and registry. Prefer named imports, e.g. `import { User } from "@/components/icons"`.
 *
 * **Reuse scope:** Project-wide.
 */
export type { CanonicalIconName } from "@/components/icons/icons-utils/canonical-icon-names";
export { CANONICAL_ICON_NAMES } from "@/components/icons/icons-utils/canonical-icon-names";
export { create_placeholder_icon } from "@/components/icons/icons-utils/create-placeholder-icon";
export type { IconColorToken, IconProps, PlaceholderIconProps } from "@/components/icons/icons-utils/icon-props";
export * from "@/components/icons/icons-utils/icon-barrel.generated";
export * from "@/components/icons/icons-utils/custom-layout-icons";
export {
    ICON_COMPONENT_BY_NAME,
    get_icon_component,
} from "@/components/icons/icons-utils/icon-component-registry";
